import {Component, ContentChild} from '@angular/core';
import {NavigationComponent} from '../../Application/Navigation/navigation.component';
import {ClientInfoService} from '../../ClientInfo/client-info.service';

@Component({
    selector: 'burncase-editor-nav',
    templateUrl: './editor-nav.component.html',
    styleUrls: ['./editor-nav.component.css']
})
export class EditorNavComponent {

    @ContentChild(NavigationComponent, {static: false}) test: NavigationComponent;

    // private _drawMode: false;

    constructor(public clientInfoService: ClientInfoService) {
        /*this.controlService.getDrawMode().subscribe((res) => {
            // console.log(res);
            this._drawMode = (res as any);
        });*/
    }

}
